import { Result } from '@standardnotes/domain-core';
export class ListAuthenticators {
    constructor(authenticatorClient) {
        this.authenticatorClient = authenticatorClient;
    }
    async execute() {
        const authenticators = await this.authenticatorClient.list();
        return Result.ok(authenticators);
    }
}
